import { callApi } from 'helper/promises';
import Usefetchdata from 'hooks/usefetchdata';
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DEFAULT_CRM_SCENARIO } from 'server/crm/crmMockData';

/**
 * What the CRM pages send with each call of server/crm/crmApi: the demo state
 * of the address (`?mock=`) and the signed-in user, who owns the demo's
 * tasks. `ready` waits for the user; `call(method, payload)` returns a
 * promise.
 */
const useCrmContext = () => {
  const [params] = useSearchParams();
  const { userData } = Usefetchdata();
  const scenario = params.get('mock') || DEFAULT_CRM_SCENARIO;
  const { _id: id, firstname, lastname } = userData ?? {};
  const me = useMemo(
    () => (id ? { id, firstname: firstname ?? '', lastname: lastname ?? '' } : null),
    [id, firstname, lastname],
  );
  const call = useCallback(
    (method, payload = {}) => callApi(method, { scenario, me, ...payload }),
    [scenario, me],
  );
  return { scenario, me, ready: Boolean(me), call };
};

export default useCrmContext;
